import { createMachine, assign } from 'xstate';

import {
  setFilterSections,
  setFilterOrClear,
  setFilterClear,
  setDateTabEmpty,
} from './actions';

import { INITIAL_SECTIONS, INITIAL_FILTERS } from './constants';
import { Context, Events } from './types';

export const initialContext: Context = {
  activeFilters: null,
  inlineFilters: INITIAL_FILTERS,
  sections: INITIAL_SECTIONS,
};

const billingFilters = createMachine<Context, Events>(
  {
    id: 'billingFilters',
    predictableActionArguments: true,
    initial: 'close',
    context: initialContext,
    states: {
      open: {
        on: {
          TOGGLE_SECTION: {
            actions: assign((ctx, event) => ({
              sections: {
                ...ctx.sections,
                [event.sectionName]: !ctx.sections[event.sectionName],
              },
            })),
          },
          CLOSE_FILTERS: {
            target: 'close',
            actions: [
              assign((ctx) => ({
                inlineFilters: ctx.activeFilters || INITIAL_FILTERS,
              })),
              setFilterSections,
            ],
          },
          APPLY_FILTERS: {
            target: 'close',
            actions: [setFilterOrClear, setFilterSections],
          },
          CHANGE_DATE_TAB: {
            actions: [
              assign((ctx, e) => ({
                inlineFilters: {
                  ...ctx.inlineFilters,
                  date: {
                    dateField: ctx.inlineFilters.date.dateField,
                    type: e.tabType,
                  },
                },
              })),
              'setDateTabEmpty',
            ],
          },
          CLEAR_FILTERS: {
            target: 'close',
            actions: setFilterClear,
          },
          UPDATE_FILTER: {
            actions: assign((ctx, event) => ({
              inlineFilters: {
                ...ctx.inlineFilters,
                [event.filter]: event.value,
              },
            })),
          },
        },
      },
      close: {
        on: {
          OPEN_FILTERS: {
            target: 'open',
          },
        },
      },
    },
  },
  {
    actions: setDateTabEmpty as any,
  }
);

export { billingFilters };
